import { gql } from "@apollo/client";
import { CampaignHeroFragment, DonateHeroFragment, ShortHeroFragment, TallHeroFragment, VideoHeroFragment, VoucherHeroFragment, TallHero200Fragment, ShortHero200Fragment } from '@components/Hero/Hero.fragment';



export default gql`
  ${ShortHeroFragment}
  ${ShortHero200Fragment}
  ${VideoHeroFragment}
  ${TallHeroFragment}
  ${TallHero200Fragment}
  ${CampaignHeroFragment}
  ${DonateHeroFragment}
  ${VoucherHeroFragment}
  fragment ProjectListingFragment on ListingPage {
    metatags {
      metaTitle
      metaRobots
      metaImage {
        md
      }
      metaDescription
      canonical
    }
    hero {
      ...ShortHeroParagraph
      ...TallHeroParagraph
      ...VideoHeroParagraph
      ...CampaignHeroParagraph
      ...VoucherHeroParagraph
      ...DonateHeroParagraph
      ...TallHero200Paragraph
      ...ShortHero200Paragraph
    }
    content {
      alignment
      text {
        processed
        format
        value
      }
    }
    searchFilters {
      name
      values
    }
    searchResults {
      total
      pageSize
      page
      totalPages
      resultList {
        id
        title
        path
        teaserImage {
          altText
          url
          sm
          md
          lg
          xl
        }
        teaserDescription
        teaserEyebrow
      }
    }
  }
`;
